// import { onAuthStateChanged } from "firebase/auth";
// import { doc, setDoc } from "firebase/firestore";
// Replaced with backend API calls
import { useCallback } from 'react';
import fetchWithTimeout from '../../../utils/fetchWithTimeout';
import API_URL from '../../../utils/api';

export default function useCompleteProfile({ auth, db, navigate, setError, setLoading }) {
  // Logic only, states are in the component
  // Replace with backend session check if needed
  const checkAuth = useCallback(async () => {
    try {
      // Get userId from localStorage (set after login)
      const userId = sessionStorage.getItem("userId") || localStorage.getItem("userId");
      if (!userId) {
        navigate("/auth");
        return;
      }
      const response = await fetchWithTimeout(`${API_URL}/api/auth/me?userId=${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }, 5000); // 5 second timeout
      const result = await response.json();
      if (!response.ok || !result.user) {
        navigate("/auth");
        return;
      }
    } catch (err) {
      // Don't redirect on network errors, just log them
      // This prevents issues with browser extensions or temporary network problems
      }
  }, [navigate]);
  const handleSubmit = useCallback(async (e, _userId, dob, gender, customGender, interests, bio, country, profilePic) => {
    e.preventDefault();
    setError("");
    const userId = sessionStorage.getItem("userId") || localStorage.getItem("userId");
    // Accept all required fields (treat empty string as missing)
    const requiredFields = [dob, gender, interests, bio, country, profilePic];
    if (requiredFields.some(f => typeof f !== 'string' || f.trim() === '')) {
      setError("Please fill in all fields.");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/profile/complete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          dob,
          gender: gender === "Other" ? customGender : gender,
          interests,
          bio,
          country,
          profile_pic: profilePic
        })
      });
      const result = await response.json();
      if (response.ok) {
        navigate("/dashboard");
      } else {
        setError(result.message || "Failed to save profile. Try again.");
      }
    } catch (err) {
      setError("Failed to save profile. Try again.");
    }
    setLoading(false);
  }, [navigate, setError, setLoading]);
  return { checkAuth, handleSubmit };
}
